import styled from "@emotion/styled";
import Box from "@mui/material/Box";
import { COLOR_BORDER } from "shared/theme/colors";
import { flex } from "shared/theme/mixins";

export const StyledDetailsItem = styled(Box)`
  ${flex({ ai: "center" })};
  height: 48px;
  padding: 0 1rem;
  border-bottom: 1px solid ${COLOR_BORDER};

  :last-child {
    border-bottom: none;
  }
`;

export const StyledDetailsTitle = styled(Box)`
  width: 224px;
  ${flex({ ai: "center" })};

  svg {
    margin-right: 1rem;
  }
`;
